import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { LocationInfoMap } from '@fcom/dapi/interfaces/itinerary.interface';
import { FinnairBoundItem } from '@fcom/dapi/api/models/finnair-bound-item';
import { FinnairCabinClass } from '@fcom/dapi/api/models/finnair-cabin-class';

@Component({
  selector: 'fin-included-tickets',
  templateUrl: './included-tickets.component.html',
  styleUrls: ['included-tickets.component.scss', '../../../../../common-booking/assets/helper-classes.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IncludedTicketsComponent {
  readonly FinnairCabinClass = FinnairCabinClass;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() locations: LocationInfoMap;
  @Input() bound: FinnairBoundItem;
  @Input() useCabinClass: boolean;
}
